import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {LoaderService} from "../services/loader.service";
import { CommonModule, NgIf } from '@angular/common';

@Component({
  selector: 'loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, AfterViewChecked {
  constructor(public loaderService: LoaderService,private cdRef: ChangeDetectorRef) {
    loaderService.isLoading.subscribe((res: any) => {});
  }

  ngOnInit(): void {

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
}
